/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { use } from 'fierry/react';

import Route from 'solis/route';
import Galaxy from 'solis/application/galaxy';

import * as Board from 'solis/react/board';

import ColonyData from 'solis/react/board/data/colony';
import StyledData from 'solis/react/board/data/styled';

import OriginSectorEmphasis from 'solis/react/board/emphasis/origin.sector';
import NotEmphasis from 'solis/react/board/emphasis/not';
import NoneEmphasis from 'solis/react/board/emphasis/none';


const createDimming = (colony, account, emphasis) =>
{
  return colony.cass.user === account.cass.id ? new NoneEmphasis() : new NotEmphasis(emphasis);
};


const createData = (colony, account) =>
{
  const emphasis = new OriginSectorEmphasis(account.cass.id);

  const colonyData = new ColonyData({ colony });

  return new StyledData({ data: colonyData, emphasis, dimming: createDimming(colony, account, emphasis) });
};


export default () =>
{
  const route = use(Route);
  const galaxy = use(Galaxy);

  const colony = galaxy.getColony(route.getArg('id'));
  const account = galaxy.getCurrentAccount();

  const data = createData(colony, account);

  return (
    <Flex direction = 'column' gap = '3' p = '5'>
      <Board.WithData data = {data} width = {680} height = {600} zoom = {3} settings = {Board.Focused} />
    </Flex>
  );
};
